<div (click)="open()">
  <ng-content></ng-content>
</div>

<ng-template #walletCreationModal>
  <div class="modal-content">
    <form [formGroup]="form" (ngSubmit)="onSubmit(model)">
      <div class="modal-header">
        <h5 class="modal-title">{{'system.create_new' | transloco: { item: 'system.items.transaction' | transloco } }}</h5>
        <button
          type="button"
          class="btn-close m-0"
          aria-label="Close"
          (click)="closeModal()"
        ></button>
      </div>
      <div class="modal-body">
        <app-space-mini-card [space]="space"></app-space-mini-card>

        <div
          class="row g-9 mb-8"
          data-kt-buttons="true"
          data-kt-buttons-target="[data-kt-button='true']"
          data-kt-initialized="1"
        >
          <!--begin::Col-->
          <div class="col">
            <!--begin::Option-->
            <label
              class="btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6"
              data-kt-button="true"
            >
              <!--begin::Radio-->
              <span
                class="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1"
              >
                <input
                  formControlName="transactionType"
                  class="form-check-input"
                  type="radio"
                  name="transactionType"
                  [value]="transactionTypeEnum.expense"
                />
              </span>
              <!--end::Radio-->

              <!--begin::Info-->
              <span class="mx-3">
                <span class="fs-4 fw-bold text-gray-800 d-block">{{'system.expenses' | transloco}}</span>
              </span>
              <!--end::Info-->
            </label>
            <!--end::Option-->
          </div>
          <!--end::Col-->

          <!--begin::Col-->
          <div class="col">
            <!--begin::Option-->
            <label
              class="btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6"
              data-kt-button="true"
            >
              <!--begin::Radio-->
              <span
                class="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1"
              >
                <input
                  formControlName="transactionType"
                  class="form-check-input"
                  type="radio"
                  name="transactionType"
                  [value]="transactionTypeEnum.income"
                />
              </span>
              <!--end::Radio-->

              <!--begin::Info-->
              <span class="mx-3">
                <span class="fs-4 fw-bold text-gray-800 d-block">{{'system.income' | transloco}}</span>
              </span>
              <!--end::Info-->
            </label>
            <!--end::Option-->
          </div>
          <!--end::Col-->

          <!--begin::Col-->
          <div class="col">
            <!--begin::Option-->
            <label
              class="btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6"
              data-kt-button="true"
            >
              <!--begin::Radio-->
              <span
                class="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1"
              >
                <input
                  formControlName="transactionType"
                  class="form-check-input"
                  type="radio"
                  name="transactionType"
                  [value]="transactionTypeEnum.debt"
                />
              </span>
              <!--end::Radio-->

              <!--begin::Info-->
              <span class="mx-3">
                <span class="fs-4 fw-bold text-gray-800 d-block">{{'system.debt' | transloco}}</span>
              </span>
              <!--end::Info-->
            </label>
            <!--end::Option-->
          </div>
          <!--end::Col-->
          <!--begin::Col-->
          <div class="col">
            <!--begin::Option-->
            <label
              class="btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6"
              data-kt-button="true"
            >
              <!--begin::Radio-->
              <span
                class="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1"
              >
                <input
                  formControlName="transactionType"
                  class="form-check-input"
                  type="radio"
                  name="transactionType"
                  [value]="transactionTypeEnum.credit"
                />
              </span>
              <!--end::Radio-->

              <!--begin::Info-->
              <span class="mx-3">
                <span class="fs-4 fw-bold text-gray-800 d-block">{{'system.credit' | transloco}}</span>
              </span>
              <!--end::Info-->
            </label>
            <!--end::Option-->
          </div>
          <!--end::Col-->
        </div>

        <formly-form
          [form]="form"
          [fields]="fields"
          [model]="model"
        ></formly-form>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-primary">{{'system.create' | transloco}}</button>
      </div>
    </form>
  </div>
</ng-template>
